import { MobileStepper, Stepper, Step, StepLabel, Avatar, styled, StepConnector } from '@mui/material';
import { stepConnectorClasses } from '@mui/material/StepConnector';

import { questions } from '../data';


const CustomStepper = ({ isMobile, activeStep, completedSteps }) => {
    if (isMobile) {
        return (
            <MobileStepper
                variant="dots"
                steps={questions.length}
                position="static"
                activeStep={activeStep}
                sx={{ justifyContent: 'center' }}
            />
        );
    }

    const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
        [`&.${stepConnectorClasses.alternativeLabel}`]: {
            top: 28,
        },
        [`& .${stepConnectorClasses.line}`]: {
            height: 1,
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        },
    }));

    const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
        display: 'flex',
        height: 56,
        width: '56px',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 28,
        zIndex: 1,
        backgroundColor: ownerState.active ?
            theme.palette.primary.main :  // Active color
            (theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0'),
        color: ownerState.active ? '#ffffff' : undefined,

        '& .QontoStepIcon-completedIcon': {
            zIndex: 1,
        },

    }));

    function QontoStepIcon(props) {
        const { active, completed, icon, className } = props;

        return (
            <QontoStepIconRoot ownerState={{ active }} className={className}>
                {completed ? (
                    icon
                ) : (
                    <span className="QontoStepIcon-circle">{icon}</span>
                )}
            </QontoStepIconRoot>
        );
    }
    return (
            <Stepper activeStep={activeStep} alternativeLabel connector={<CustomStepConnector />}>
                {questions.map((q, index) => (
                        <Step completed={!!completedSteps[q.id]}>
                            <StepLabel
                                StepIconComponent={props => (
                                    <QontoStepIcon
                                        {...props}
                                        icon={completedSteps[q.id] ?
                                            <Avatar
                                                src={completedSteps[q.id]}
                                                alt="selected option"
                                                sx={{ width: '56px', height: '56px', zIndex: 999 }}
                                            />
                                            :
                                            index + 1
                                        }
                                    />
                                )}
                            />
                        </Step>
                ))}
            </Stepper>
    );
};

export default CustomStepper;